const EXTRAS = {
    SHOW_CONFIRMED: 'show_confirmed',
    TRAVEL_BOOSTER_NOT_SYNCED: 'travel_booster_not_synced',
    SHOW_UPCOMING: 'show_upcoming',
    SHOW_ONGOING: 'show_ongoing',
    CANCELLATION_DEADLINE: 'cancellation_deadline',
    BOOKINGS_FROM_BRANCH: 'bookings_from_branch',
    AGENCY_BRANCHES: 'agency_branches',
    FURTHEST_DEADLINE: 'furthest_deadline',
    CLOSEST_DEADLINE: 'closest_deadline_excludes_passed_due',
    CLOSEST_DEADLINE_PASSED: 'closest_deadline_includes_passed_due',
}

module.exports = {
    EXTRAS
}